// Drawer.js — 오른쪽에서 밀려나오는 상세 패널 (캘린더 날짜 상세, 음식 상세). 모바일은 전체 화면
import React, { useEffect } from 'react';
import './ui.css';

export default function Drawer({ open, title, onClose, footer, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      <div className={`drawer-dim${open ? ' open' : ''}`} onClick={onClose} />
      <aside className={`drawer${open ? ' open' : ''}`} aria-hidden={!open} aria-label={title}>
        <header className="drawer-head">
          <h2>{title}</h2>
          <button type="button" className="icon-btn" aria-label="닫기" onClick={onClose}>✕</button>
        </header>
        <div className="drawer-body">{open && children}</div>
        {open && footer && <footer className="drawer-foot">{footer}</footer>}
      </aside>
    </>
  );
}
